/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  Deletable,
  DeletableOptional,
  DeletableMetaI,
  DeletableTrackedI,
} from "./deletable";
import { DeletableTracked, DeletableMeta } from "./deletable";
// May contain unused imports in some cases
// @ts-ignore
import type {
  RatingBase,
  RatingBaseOptional,
  RatingBaseMetaI,
  RatingBaseTrackedI,
} from "./rating-base";
import { RatingBaseTracked, RatingBaseMeta } from "./rating-base";
// May contain unused imports in some cases
// @ts-ignore
import type {
  RatingRef,
  RatingRefOptional,
  RatingRefMetaI,
  RatingRefTrackedI,
} from "./rating-ref";
import { RatingRefTracked, RatingRefMeta } from "./rating-ref";

/**
 *
 * @export
 * @interface RatingFull
 */
export interface RatingFullOptional extends DeletableOptional {
  /**
   *
   * @type {number}
   * @memberof RatingFull
   */
  assignId?: number;
  /**
   *
   * @type {string}
   * @memberof RatingFull
   */
  ratingName?: string;
  /**
   *
   * @type {number}
   * @memberof RatingFull
   */
  displayOrder?: number;
  /**
   *
   * @type {boolean}
   * @memberof RatingFull
   */
  active?: boolean;
  /**
   *
   * @type {number}
   * @memberof RatingFull
   */
  testMinCrew?: number;
  /**
   *
   * @type {number}
   * @memberof RatingFull
   */
  testMaxCrew?: number;
  /**
   *
   * @type {boolean}
   * @memberof RatingFull
   */
  testable?: boolean;
  /**
   *
   * @type {string}
   * @memberof RatingFull
   */
  ratingCategory?: string;
  /**
   *
   * @type {boolean}
   * @memberof RatingFull
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof RatingFull
   */
  isNew?: boolean;
  /**
   *
   * @type {RatingRef}
   * @memberof RatingFull
   */
  overriddenBy?: RatingRefOptional;
}

export interface RatingFull
  extends RatingFullOptional, Deletable, RatingBase, RatingRef {
  /**
   *
   * @type {number}
   * @memberof RatingFull
   */
  assignId: number;
  /**
   *
   * @type {string}
   * @memberof RatingFull
   */
  ratingName?: string;
  /**
   *
   * @type {number}
   * @memberof RatingFull
   */
  displayOrder?: number;
  /**
   *
   * @type {boolean}
   * @memberof RatingFull
   */
  active?: boolean;
  /**
   *
   * @type {number}
   * @memberof RatingFull
   */
  testMinCrew?: number;
  /**
   *
   * @type {number}
   * @memberof RatingFull
   */
  testMaxCrew?: number;
  /**
   *
   * @type {boolean}
   * @memberof RatingFull
   */
  testable?: boolean;
  /**
   *
   * @type {string}
   * @memberof RatingFull
   */
  ratingCategory?: string;
  /**
   *
   * @type {boolean}
   * @memberof RatingFull
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof RatingFull
   */
  isNew?: boolean;
  /**
   *
   * @type {RatingRef}
   * @memberof RatingFull
   */
  overriddenBy?: RatingRef;
}

export interface RatingFullTrackedI extends DeletableOptional {
  /**
   *
   * @type {number}
   * @memberof RatingFull
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof RatingFull
   */
  ratingName?: string;
  ratingNameIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof RatingFull
   */
  displayOrder?: number;
  displayOrderIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof RatingFull
   */
  active?: boolean;
  activeIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof RatingFull
   */
  testMinCrew?: number;
  testMinCrewIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof RatingFull
   */
  testMaxCrew?: number;
  testMaxCrewIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof RatingFull
   */
  testable?: boolean;
  testableIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof RatingFull
   */
  ratingCategory?: string;
  ratingCategoryIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof RatingFull
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof RatingFull
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {RatingRef}
   * @memberof RatingFull
   */
  overriddenBy?: RatingRefTrackedI;
  overriddenByIsSet: boolean;
}

transformDatesMap.set("RatingFull", function (model: RatingFull) {
  const transformDatesoverriddenBy = transformDatesMap.get("RatingRef");
  if (transformDatesoverriddenBy && model.overriddenBy) {
    transformDatesoverriddenBy(model.overriddenBy);
  }
});

export type RatingFullMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  ratingName: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  displayOrder: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  active: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  testMinCrew: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  testMaxCrew: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  testable: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  ratingCategory: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  overriddenBy: PropertyMeta<RatingRefMetaI>;
}>;

export var RatingFullMeta: RatingFullMetaI = {} as RatingFullMetaI;
RatingFullMeta = typeMeta("RatingFull", {
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  ratingName: propertyMeta(
    "ratingName",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  displayOrder: propertyMeta(
    "displayOrder",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  active: propertyMeta("active", false, false, false, MetaTypesBase.boolean),
  testMinCrew: propertyMeta(
    "testMinCrew",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  testMaxCrew: propertyMeta(
    "testMaxCrew",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  testable: propertyMeta(
    "testable",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  ratingCategory: propertyMeta(
    "ratingCategory",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  overriddenBy: propertyMeta(
    "overriddenBy",
    false,
    false,
    false,
    RatingRefMeta,
  ),
});

const metaI = RatingFullMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([RatingRefMeta]);
  metaI.assignId.inheritedFrom = RatingRefMeta.assignId;
  metaI.interfaces = metaI.interfaces.concat([RatingBaseMeta]);
  metaI.ratingName.inheritedFrom = RatingBaseMeta.ratingName;
  metaI.displayOrder.inheritedFrom = RatingBaseMeta.displayOrder;
  metaI.active.inheritedFrom = RatingBaseMeta.active;
  metaI.testMinCrew.inheritedFrom = RatingBaseMeta.testMinCrew;
  metaI.testMaxCrew.inheritedFrom = RatingBaseMeta.testMaxCrew;
  metaI.testable.inheritedFrom = RatingBaseMeta.testable;
  metaI.ratingCategory.inheritedFrom = RatingBaseMeta.ratingCategory;
  metaI.interfaces = metaI.interfaces.concat([DeletableMeta]);
  metaI.isDeleted.inheritedFrom = DeletableMeta.isDeleted;
  metaI.isNew.inheritedFrom = DeletableMeta.isNew;
});

export class RatingFullTracked
  extends DeletableTracked
  implements RatingFullTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  ratingName__I?: string = undefined;
  ratingNameIsSet: boolean = false;
  set ratingName(v: undefined | string) {
    if (v !== undefined) {
      this.ratingName__I = v;
      this.ratingNameIsSet = true;
    } else {
      this.ratingName__I = v || undefined;
      this.ratingNameIsSet = false;
    }
    this.changeTracker = true;
  }
  get ratingName() {
    return this.ratingName__I;
  }
  displayOrder__I?: number = undefined;
  displayOrderIsSet: boolean = false;
  set displayOrder(v: undefined | number) {
    if (v !== undefined) {
      this.displayOrder__I = v;
      this.displayOrderIsSet = true;
    } else {
      this.displayOrder__I = v || undefined;
      this.displayOrderIsSet = false;
    }
    this.changeTracker = true;
  }
  get displayOrder() {
    return this.displayOrder__I;
  }
  active__I?: boolean = undefined;
  activeIsSet: boolean = false;
  set active(v: undefined | boolean) {
    if (v !== undefined) {
      this.active__I = v;
      this.activeIsSet = true;
    } else {
      this.active__I = v || undefined;
      this.activeIsSet = false;
    }
    this.changeTracker = true;
  }
  get active() {
    return this.active__I;
  }
  testMinCrew__I?: number = undefined;
  testMinCrewIsSet: boolean = false;
  set testMinCrew(v: undefined | number) {
    if (v !== undefined) {
      this.testMinCrew__I = v;
      this.testMinCrewIsSet = true;
    } else {
      this.testMinCrew__I = v || undefined;
      this.testMinCrewIsSet = false;
    }
    this.changeTracker = true;
  }
  get testMinCrew() {
    return this.testMinCrew__I;
  }
  testMaxCrew__I?: number = undefined;
  testMaxCrewIsSet: boolean = false;
  set testMaxCrew(v: undefined | number) {
    if (v !== undefined) {
      this.testMaxCrew__I = v;
      this.testMaxCrewIsSet = true;
    } else {
      this.testMaxCrew__I = v || undefined;
      this.testMaxCrewIsSet = false;
    }
    this.changeTracker = true;
  }
  get testMaxCrew() {
    return this.testMaxCrew__I;
  }
  testable__I?: boolean = undefined;
  testableIsSet: boolean = false;
  set testable(v: undefined | boolean) {
    if (v !== undefined) {
      this.testable__I = v;
      this.testableIsSet = true;
    } else {
      this.testable__I = v || undefined;
      this.testableIsSet = false;
    }
    this.changeTracker = true;
  }
  get testable() {
    return this.testable__I;
  }
  ratingCategory__I?: string = undefined;
  ratingCategoryIsSet: boolean = false;
  set ratingCategory(v: undefined | string) {
    if (v !== undefined) {
      this.ratingCategory__I = v;
      this.ratingCategoryIsSet = true;
    } else {
      this.ratingCategory__I = v || undefined;
      this.ratingCategoryIsSet = false;
    }
    this.changeTracker = true;
  }
  get ratingCategory() {
    return this.ratingCategory__I;
  }
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  overriddenBy__I?: RatingRefTracked = undefined;
  overriddenByIsSet: boolean = false;
  set overriddenBy(v: undefined | RatingRefTracked) {
    if (v !== undefined) {
      this.overriddenBy__I = v;
      this.overriddenByIsSet = true;
    } else {
      this.overriddenBy__I = v || undefined;
      this.overriddenByIsSet = false;
    }
    this.changeTracker = true;
  }
  get overriddenBy() {
    return this.overriddenBy__I;
  }
  constructor(config?: RatingFullOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }

    this.overriddenBy?.setIds();
  }
  assignFrom(
    config: RatingFullOptional,
    options?: AssignOptions,
  ): RatingFullTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (
      config.ratingName &&
      this.ratingNameApplyFilter(optionsRequired.filter)
    ) {
      this.ratingName = config.ratingName;
      if (optionsRequired.unassign) this.ratingNameIsSet = false;
      else this.ratingNameIsSet = true;
    }
    if (
      config.displayOrder &&
      this.displayOrderApplyFilter(optionsRequired.filter)
    ) {
      this.displayOrder = config.displayOrder;
      if (optionsRequired.unassign) this.displayOrderIsSet = false;
      else this.displayOrderIsSet = true;
    }
    if (config.active && this.activeApplyFilter(optionsRequired.filter)) {
      this.active = config.active;
      if (optionsRequired.unassign) this.activeIsSet = false;
      else this.activeIsSet = true;
    }
    if (
      config.testMinCrew &&
      this.testMinCrewApplyFilter(optionsRequired.filter)
    ) {
      this.testMinCrew = config.testMinCrew;
      if (optionsRequired.unassign) this.testMinCrewIsSet = false;
      else this.testMinCrewIsSet = true;
    }
    if (
      config.testMaxCrew &&
      this.testMaxCrewApplyFilter(optionsRequired.filter)
    ) {
      this.testMaxCrew = config.testMaxCrew;
      if (optionsRequired.unassign) this.testMaxCrewIsSet = false;
      else this.testMaxCrewIsSet = true;
    }
    if (config.testable && this.testableApplyFilter(optionsRequired.filter)) {
      this.testable = config.testable;
      if (optionsRequired.unassign) this.testableIsSet = false;
      else this.testableIsSet = true;
    }
    if (
      config.ratingCategory &&
      this.ratingCategoryApplyFilter(optionsRequired.filter)
    ) {
      this.ratingCategory = config.ratingCategory;
      if (optionsRequired.unassign) this.ratingCategoryIsSet = false;
      else this.ratingCategoryIsSet = true;
    }
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (
      config.overriddenBy &&
      this.overriddenByApplyFilter(optionsRequired.filter)
    ) {
      this.overriddenBy = new RatingRefTracked(config.overriddenBy, options);
      if (optionsRequired.unassign) this.overriddenByIsSet = false;
      else this.overriddenByIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): RatingFullTrackedI {
    const cloned = {} as RatingFullTrackedI;
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.ratingNameIsSetDeep() &&
      this.ratingNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.ratingNameIsSet = true;
      cloned.ratingName = this.ratingName;
    } else {
      //cloned.ratingNameIsSet = false
    }
    if (
      this.displayOrderIsSetDeep() &&
      this.displayOrderApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.displayOrderIsSet = true;
      cloned.displayOrder = this.displayOrder;
    } else {
      //cloned.displayOrderIsSet = false
    }
    if (
      this.activeIsSetDeep() &&
      this.activeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.activeIsSet = true;
      cloned.active = this.active;
    } else {
      //cloned.activeIsSet = false
    }
    if (
      this.testMinCrewIsSetDeep() &&
      this.testMinCrewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.testMinCrewIsSet = true;
      cloned.testMinCrew = this.testMinCrew;
    } else {
      //cloned.testMinCrewIsSet = false
    }
    if (
      this.testMaxCrewIsSetDeep() &&
      this.testMaxCrewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.testMaxCrewIsSet = true;
      cloned.testMaxCrew = this.testMaxCrew;
    } else {
      //cloned.testMaxCrewIsSet = false
    }
    if (
      this.testableIsSetDeep() &&
      this.testableApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.testableIsSet = true;
      cloned.testable = this.testable;
    } else {
      //cloned.testableIsSet = false
    }
    if (
      this.ratingCategoryIsSetDeep() &&
      this.ratingCategoryApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.ratingCategoryIsSet = true;
      cloned.ratingCategory = this.ratingCategory;
    } else {
      //cloned.ratingCategoryIsSet = false
    }
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.overriddenByIsSetDeep() &&
      this.overriddenByApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.overriddenByIsSet = true;
      cloned.overriddenBy = this.overriddenBy?.removeUnset(filter);
    } else {
      //cloned.overriddenByIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): RatingFullTrackedI {
    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.ratingNameApplyFilter(filter)) this.ratingNameIsSet = false;

    if (!this.displayOrderApplyFilter(filter)) this.displayOrderIsSet = false;

    if (!this.activeApplyFilter(filter)) this.activeIsSet = false;

    if (!this.testMinCrewApplyFilter(filter)) this.testMinCrewIsSet = false;

    if (!this.testMaxCrewApplyFilter(filter)) this.testMaxCrewIsSet = false;

    if (!this.testableApplyFilter(filter)) this.testableIsSet = false;

    if (!this.ratingCategoryApplyFilter(filter))
      this.ratingCategoryIsSet = false;

    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.overriddenByApplyFilter(filter)) this.overriddenByIsSet = false;
    this.overriddenBy?.unassignAll(filter);

    return this;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(RatingFullMeta.assignId, RatingFullMeta, this.assignId, this);
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  ratingNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      RatingFullMeta.ratingName,
      RatingFullMeta,
      this.ratingName,
      this,
    );
  }
  ratingNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.ratingNameIsSet && this.ratingNameApplyFilter(filter)) return true;

    return false;
  }
  displayOrderApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      RatingFullMeta.displayOrder,
      RatingFullMeta,
      this.displayOrder,
      this,
    );
  }
  displayOrderIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.displayOrderIsSet && this.displayOrderApplyFilter(filter))
      return true;

    return false;
  }
  activeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(RatingFullMeta.active, RatingFullMeta, this.active, this);
  }
  activeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.activeIsSet && this.activeApplyFilter(filter)) return true;

    return false;
  }
  testMinCrewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      RatingFullMeta.testMinCrew,
      RatingFullMeta,
      this.testMinCrew,
      this,
    );
  }
  testMinCrewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.testMinCrewIsSet && this.testMinCrewApplyFilter(filter))
      return true;

    return false;
  }
  testMaxCrewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      RatingFullMeta.testMaxCrew,
      RatingFullMeta,
      this.testMaxCrew,
      this,
    );
  }
  testMaxCrewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.testMaxCrewIsSet && this.testMaxCrewApplyFilter(filter))
      return true;

    return false;
  }
  testableApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(RatingFullMeta.testable, RatingFullMeta, this.testable, this);
  }
  testableIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.testableIsSet && this.testableApplyFilter(filter)) return true;

    return false;
  }
  ratingCategoryApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      RatingFullMeta.ratingCategory,
      RatingFullMeta,
      this.ratingCategory,
      this,
    );
  }
  ratingCategoryIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.ratingCategoryIsSet && this.ratingCategoryApplyFilter(filter))
      return true;

    return false;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      RatingFullMeta.isDeleted,
      RatingFullMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(RatingFullMeta.isNew, RatingFullMeta, this.isNew, this);
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  overriddenByApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      RatingFullMeta.overriddenBy,
      RatingFullMeta,
      this.overriddenBy,
      this,
    );
  }
  overriddenByIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.overriddenByIsSet && this.overriddenByApplyFilter(filter))
      return true;
    return this.overriddenBy?.anySet(filter) == true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.ratingNameIsSetDeep(filter)) return true;
    if (this.displayOrderIsSetDeep(filter)) return true;
    if (this.activeIsSetDeep(filter)) return true;
    if (this.testMinCrewIsSetDeep(filter)) return true;
    if (this.testMaxCrewIsSetDeep(filter)) return true;
    if (this.testableIsSetDeep(filter)) return true;
    if (this.ratingCategoryIsSetDeep(filter)) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.overriddenByIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
